module.exports = __webpack_public_path__ + "static/media/design-circle.b78a3768.svg";